import { render } from "./collectData.vue?vue&type=template&id=24b310e3"
import script from "./collectData.vue?vue&type=script&lang=js"
export * from "./collectData.vue?vue&type=script&lang=js"

import "./collectData.vue?vue&type=style&index=0&id=24b310e3&lang=less"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__